// Librerias
import React from 'react'
let PropTypes = React.PropTypes
import { AutoSizer, Table, Column } from 'react-virtualized'
// API
import api from '../../apiClient/v1'
// Componentes
import Modal from 'react-bootstrap/lib/Modal.js'
// Style
import classNames from 'classnames/bind'
import * as cssModal from '../diferencias-inventarios/modal.css'
let css = classNames.bind(cssModal)

export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = { visible: false }
        this.show  = ()=> this.setState({visible: true})
        this.hide  = ()=> this.setState({visible: false})
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class ModalDetalle extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            bloqueado: false,
            aprobadoFacturar: false
        }
        this.fetchDetalleFactura = ()=>{
            let mes = this.props.mes
            api.inventario.getAprobadosMesCliente(mes, 12)
                .then(detalle=>{
                    this.setState({unidades: detalle.sumaUnidades})
                    this.setState({total: detalle.total})
                    this.setState({totalNeto: detalle.totalNeto})
                    this.setState({aprobadoFacturar: detalle.aprobadoFacturar})
                })
                .catch(error=>{console.log("error")})
        }
        this.handleSubmit = (evt)=>{
            this.setState({bloqueado: true})
            evt.preventDefault()
            evt.stopPropagation()
            this.setState(()=>{
                this.context.correoSEI()
                    .then(()=>{
                        this.setState({bloqueado: false})
                        this.props.hideModal()
                    })
                    .catch(error=>{
                        console.log("error")
                    })
            })
        }
    }
    componentWillMount() {
        this.fetchDetalleFactura()
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} className={css('modale')}>
                <Modal.Header closeButton>
                    <Modal.Title>Información de facturación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul className={'list-group'}>
                        <strong>Unidades</strong>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>{this.state.unidades}</span>
                            Total unidades aprobadas
                        </li>
                    </ul>
                    <strong>Valores</strong>
                    <ul className={'list-group'}>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>${this.state.total}</span>
                            Valor neto
                        </li>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>${this.state.totalNeto}</span>
                            Valor bruto
                        </li>
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <form onSubmit={this.handleSubmit}>
                        <button type={'submit'} className={'btn btn-primary'} disabled={this.state.bloqueado || this.state.aprobadoFacturar == false}>Aprobar Facturación</button>
                        <button type={'button'} className={'btn btn-secondary'} onClick={this.props.hideModal}>Cancelar</button>
                    </form>
                </Modal.Footer>
            </Modal>
        )
    }
}
ModalDetalle.contextTypes = {
    correoSEI: PropTypes.func
}
export class ModalFacturacion extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            bloqueado: false,
            aprobadoFacturar: false
        }
        this.fetchDetalleFactura = ()=>{
            let mes = this.props.mes
            api.inventario.getAprobadosSEIMesCliente(mes, 12)
                .then(detalle=>{
                    this.setState({unidades: detalle.sumaUnidades})
                    this.setState({total: detalle.total})
                    this.setState({totalNeto: detalle.totalNeto})
                    this.setState({aprobadoFacturar: detalle.aprobadoFacturar})
                })
                .catch(error=>{console.log("error")})
        }
        this.handleSubmit = (evt)=>{
            this.setState({bloqueado: true})
            evt.preventDefault()
            evt.stopPropagation()
            this.setState(()=>{
                this.context.generarFacturaTxt()
                    .then(()=>{
                        this.setState({bloqueado: false})
                        this.props.hideModal()
                    })
                    .catch(error=>{
                        console.log("error")
                    })
            })
        }
    }
    componentWillMount() {
        this.fetchDetalleFactura()
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} className={css('modale')}>
                <Modal.Header closeButton>
                    <Modal.Title>Información de facturación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul className={'list-group'}>
                        <strong>Unidades</strong>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>{this.state.unidades}</span>
                            Total unidades aprobadas
                        </li>
                    </ul>
                    <strong>Valores</strong>
                    <ul className={'list-group'}>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>${this.state.total}</span>
                            Valor neto
                        </li>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>${this.state.totalNeto}</span>
                            Valor bruto
                        </li>
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <form onSubmit={this.handleSubmit}>
                        <button type={'submit'} className={'btn btn-primary'} disabled={this.state.bloqueado || this.state.aprobadoFacturar == false}>Generar Facturar</button>
                        <button type={'button'} className={'btn btn-secondary'} onClick={this.props.hideModal}>Cancelar</button>
                    </form>
                </Modal.Footer>
            </Modal>
        )
    }
}
ModalFacturacion.contextTypes = {
    generarFacturaTxt: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/inventarios/inventarios-facturacion/Modales.jsx